// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { LayoutFeatured } from './LayoutFeatured'
import { teasers as T } from '../teasers';
import { PageBlockTypes as p } from '@xprog/prensa/types'

// SuperManchete
const LayoutFeaturedRelated: p.SlotConfigProps = {
  ...LayoutFeatured,
  slotConfig: {
    ...LayoutFeatured?.slotConfig,
    TemplateSuperManchete: {
      slotLeft: {
        default: [T.TeaserBackgroundRelated, T.TeaserBackgroundRelatedLg],
      }
    }
  }
}

export { LayoutFeaturedRelated }
